import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { NavigationService } from '../../../../../../core/navigation.service';
import { LeftPanelService } from '../../../../../../layout/home/services/left-panel.service';
import { UserService } from '../../../../../../core/security/user.service';
import { ResourceService, AlertService } from 'sce-core';
import { DatePickerConfigService } from '../../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-work-orders-search',
  templateUrl: './job-maintenance-primary-accordian.component.html',
  styleUrls: ['./job-maintenance-primary-accordian.component.css']
})
export class  JobMaintenancePrimaryAccordianComponent extends AbstractFormWidgetComponent {
  public lblRules: string = this.resourceService.get('lbl_rules');
  public lblJobPrefTime: string = this.resourceService.get('lbl_jobPrefTime');
  public lblJob: string = this.resourceService.get('lbl_job');

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    public leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/work-order-management/work-order-execution/job-maintenence/job-maintenance-primary-accordian/job-maintenance-primary-accordian.component.ts